import React from 'react';
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { reduxForm, Field, submit } from 'redux-form';
import {Collapse} from 'react-collapse';

import update from 'immutability-helper';
import moment from 'moment-timezone';

import { TicketsService, TimeFormattingService } from '../../services';
import TicketTaskForm from './ticket_task_form';
import {TextInput} from '../TextInput';
import i18next from "i18next";

const validate = values => {
  const errors = {}

  if (!values.comment) {
    errors.comment = i18next.t('messages.please-enter-comment')
  }
  return errors
}

class TicketActivityList extends React.Component {

  constructor(props) {
    super(props);
    let showCollapseAll = false;
    let completedCount=0;
    this.props.ticket.tasks.map(function(item){
      item.isOpened= true;
      if(item.status.name.replace(/\s+/g, '-').toLowerCase() === 'complete'){
        item.isOpened= false;
        completedCount++;
      }
      return item;
    })
    if(completedCount > 0){
      showCollapseAll = true;
    }

    this.state = {
      ticket: this.props.ticket,
      comments: this.props.ticket.comments,
      tasks: this.props.ticket.tasks,
      linkTo: null,
      localErrorHandler: this.props.localErrorHandler,
      hasError: false,
      showAddTicketCommentModal: false,
      showAddEditTicketTaskModal: false,
      showAddTicketTaskCommentModal: false,
      commentingOnTicketTask: null,
      isOpenedAll:false,
      showCollapseAll : showCollapseAll
    };

    this.toggleAddTicketCommentModal = this.toggleAddTicketCommentModal.bind(this);
    this.toggleAddEditTicketTaskModal = this.toggleAddEditTicketTaskModal.bind(this);
    this.toggleAddTicketTaskCommentModal = this.toggleAddTicketTaskCommentModal.bind(this);
    this.toggleCollapsePanel = this.toggleCollapsePanel.bind(this);
  }

  toggleAddTicketCommentModal() {
    this.setState({ showAddTicketCommentModal: !this.state.showAddTicketCommentModal });
  }

  saveAddTicketCommentModal() {
    this.props.dispatch(submit('TicketCommentForm'));
  }

  submitAddTicketCommentModal({ comment }) {
    TicketsService.addComment(this.state.ticket.id, {comment: comment}).then(response => {
     this.props.refreshTicket();
      this.toggleAddTicketCommentModal();
      this.props.handleLocalSuccess( i18next.t('messages.comment-added-success') );
    }).catch(error => {
      this.toggleAddTicketCommentModal();
      this.props.localErrorHandler( i18next.t('messages.comment-added-failure') );
      console.error(error);
    });
  }

  toggleAddEditTicketTaskModal(task) {
    this.setState({
      editingTask: task,
      showAddEditTicketTaskModal: !this.state.showAddEditTicketTaskModal
    });
  }

  toggleCollapsePanel(taskRow){
     this.setState({tasks:  this.props.ticket.tasks.map(function(item){
      if(item.id === taskRow.id){
        if(item.isOpened){ item.isOpened = false; } else { item.isOpened = true;}
      }
      return item;
      })
    });
    //toggle collapse all button if all completed task are collapse.
    var isAllCollapsed = this.props.ticket.tasks.find(task => task.isOpened === true && task.status.name.replace(/\s+/g, '-').toLowerCase() === 'complete' ) ? true : false;
    this.setState({ isOpenedAll: isAllCollapsed });
  }
  toggleCollapseAllPanel(){
    this.setState({ isOpenedAll: !this.state.isOpenedAll });
    const  isOpenedAll = this.state.isOpenedAll;
    this.setState({tasks:  this.state.tasks.map(function(item){
      if(item.status.name.replace(/\s+/g, '-').toLowerCase() === 'complete'){
        if(isOpenedAll){ item.isOpened = false; } else { item.isOpened = true;}
      }
      return item;
      })
    });
  }

  saveAddEditTicketTaskModal() {
    this.props.dispatch(submit('TicketTaskForm'));
  }

  submitAddEditTicketTaskModal({ description, type, status, assignedTo }) {
    let task = {
      description: description,
      status: { id: status.value },
      type: { id: type.value }
    };

    if (assignedTo) {
      task['assignedTo'] = { id: assignedTo.value };
    }

    if (this.state.editingTask) {
      task['id'] = this.state.editingTask.id;
      TicketsService.updateTask(this.state.ticket.id, task).then(response => {
        this.props.refreshTicket();
        this.toggleAddEditTicketTaskModal(null);
        this.props.handleLocalSuccess( i18next.t('messages.task-update-success') );
      }).catch(error => {
        this.toggleAddEditTicketTaskModal(null);
        this.props.localErrorHandler( i18next.t('messages.task-update-failure') );
        console.error(error);
      });
    } else {
      TicketsService.addTask(this.state.ticket.id, task).then(response => {
        this.props.refreshTicket();
        this.toggleAddEditTicketTaskModal(null);
        this.props.handleLocalSuccess( i18next.t('messages.task-add-success') );
      }).catch(error => {
        this.toggleAddEditTicketTaskModal(null);
        this.props.localErrorHandler( i18next.t('messages.task-add-success') );
        console.error(error);
      });
    }
  }

  toggleAddTicketTaskCommentModal(task) {
    this.setState({
      showAddTicketTaskCommentModal: !this.state.showAddTicketTaskCommentModal,
      commentingOnTicketTask: task
    });
  }

  saveAddTicketTaskCommentModal() {
    this.props.dispatch(submit('TicketTaskCommentForm'));
  }

  submitAddTicketTaskCommentModal(comment) {
    if (this.state.commentingOnTicketTask) {
      TicketsService.addTaskComment(this.state.ticket.id, this.state.commentingOnTicketTask.id, comment).then(response => {
        const tasks = this.state.tasks.map(task => {
          if (task.id === this.state.commentingOnTicketTask.id) {
            return update(task, { comments: { $set: response.data } });
          } else {
            return task;
          }
        })

        this.props.refreshTicket();
        this.toggleAddTicketTaskCommentModal(null);

        this.props.handleLocalSuccess( i18next.t('messages.task-comment-add-success') );
      }).catch(error => {
        this.toggleAddTicketTaskCommentModal(null);
        this.props.localErrorHandler( i18next.t('messages.task-comment-add-success') );
        console.error(error);
      });
    }
  }

  render() {
    if (this.state.linkTo) {
      return <Redirect push to={this.state.linkTo} />;
    }

    let activities =
      this.state.tasks.map(task => ({ task: task, createdAt: task.createdAt })).concat(
      this.state.comments.map(comment => ({ comment: comment, createdAt: comment.createdAt })))
          .sort((activityA, activityB) => activityB.createdAt - activityA.createdAt);

    var key = 0;

    return (
      <div className="ticket-activity">
        <div className="ticket-activity__header">
          <h4 className="ticket-header">{ i18next.t('pages.tickets.activity') }</h4>
          {this.props.activityEnabled ? (
            <div className="ticket-actions">
              <a className="btn btn-sm btn-default" onClick={() => this.toggleAddEditTicketTaskModal(null)}>{ i18next.t('form-labels.add-task') }</a>
              <a className="btn btn-sm btn-default" onClick={this.toggleAddTicketCommentModal}>{ i18next.t('form-labels.add-comment') }</a>
            </div>
          ) : <em>{ i18next.t('messages.ticket-status-must-be-acknowledged') }</em>}
          {this.state.showCollapseAll &&
            <a className="btn btn-sm btn-default" onClick={() => this.toggleCollapseAllPanel()}>
              {this.state.isOpenedAll ? i18next.t('form-labels.collapse-all') : i18next.t('form-labels.expand-all')}
            </a>
          }
        </div>

        {activities.length === 0 ?
          <div className="ticket-activity__none">{ i18next.t('messages.no-activity-yet') }</div> : (
            <div className="ticket-activity__listing">
              {
                activities.map(activity => (
                  <ActivityEntry
                    key={key++}
                    timezone={this.state.ticket.deviceGrouping.timezone}
                    toggleAddEditTicketTaskModal={this.toggleAddEditTicketTaskModal}
                    toggleAddTicketTaskCommentModal={this.toggleAddTicketTaskCommentModal}
                    toggleCollapsePanel={this.toggleCollapsePanel}
                    activity={activity}
                    activityEnabled={this.props.activityEnabled}
                  />
                )
                )
              }
            </div>
          )
        }

        <Modal className="modal-add-grouping" show={this.state.showAddTicketCommentModal} onHide={this.toggleAddTicketCommentModal}>
          <Modal.Header closeButton>
            <Modal.Title>{ i18next.t('pages.tickets.ticket-comment') }</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <TicketCommentForm onSubmit={this.submitAddTicketCommentModal.bind(this)} />

          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.saveAddTicketCommentModal.bind(this)}>{ i18next.t('form-labels.save') }</Button>
            <Button onClick={this.toggleAddTicketCommentModal}>{ i18next.t('form-labels.cancel') }</Button>
          </Modal.Footer>
        </Modal>


        <Modal className="modal-add-grouping" show={this.state.showAddEditTicketTaskModal} onHide={() => this.toggleAddEditTicketTaskModal(null)}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.editingTask == null ? <span>{ i18next.t('form-labels.add') }</span> : <span>{ i18next.t('form-labels.edit') }</span>} { i18next.t('pages.tickets.task') }</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <TicketTaskForm
              task={this.state.editingTask}
              taskStatuses={this.props.taskStatuses}
              taskTypes={this.props.taskTypes}
              onSubmit={this.submitAddEditTicketTaskModal.bind(this)}
            />

          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.saveAddEditTicketTaskModal.bind(this)}>{ i18next.t('form-labels.save') }</Button>
            <Button onClick={() => this.toggleAddEditTicketTaskModal(null)}>{ i18next.t('form-labels.cancel') }</Button>
          </Modal.Footer>
        </Modal>


        <Modal className="modal-add-grouping" show={this.state.showAddTicketTaskCommentModal} onHide={() => this.toggleAddTicketTaskCommentModal(null)}>
          <Modal.Header closeButton>
            <Modal.Title>Task Comment</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <TicketTaskCommentForm onSubmit={this.submitAddTicketTaskCommentModal.bind(this)} />

          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.saveAddTicketTaskCommentModal.bind(this)}>{ i18next.t('form-labels.save') }</Button>
            <Button onClick={() => this.toggleAddTicketTaskCommentModal(null)}>{ i18next.t('form-labels.cancel') }</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const ActivityEntry = (props) => {
  return (
    props.activity.task ?
      <TaskActivityEntry
        timezone={props.timezone}
        toggleAddEditTicketTaskModal={props.toggleAddEditTicketTaskModal}
        toggleAddTicketTaskCommentModal={props.toggleAddTicketTaskCommentModal}
        toggleCollapsePanel={props.toggleCollapsePanel}
        task={props.activity.task}
        activityEnabled={props.activityEnabled}
      /> : <TicketCommentActivityEntry timezone={props.timezone} comment={props.activity.comment} />
  );
}

const TaskActivityEntry = (props) => {
  const createdByName = props.task.createdBy == null ? 'System' : props.task.createdBy.fullName;
  const updatedByName = props.task.lastUpdatedBy == null ? 'System' : props.task.lastUpdatedBy.fullName;
  const taskComments = props.task.comments.sort((commentA, commentB) => commentB.createdAt - commentA.createdAt);
  return (
    <div className = {`task-status-`+ props.task.status.name.replace(/\s+/g, '-').toLowerCase() + " " + `task-ticket-`+ props.task.type.name.toLowerCase() + `-icon` + " " + `task-status task-display-wrapper task-ticket-icon`}>
      <ul className="list-inline clearfix task-ticket-header">
        <li className="pull-left"><h4 className="remove-margin-bottom">{ i18next.t('pages.tickets.task') }</h4></li>
        <li className="pull-right">
          <ul className="list-inline remove-margin-bottom">
            { props.task.status.name.replace(/\s+/g, '-').toLowerCase() === 'complete' &&
              <li className="card-collapse-expand-button">
                <a className={props.task.isOpened ? "expanded toggle-expand" : "collapsed toggle-expand"} onClick={() => props.toggleCollapsePanel(props.task)}>
                  {props.task.isOpened ? " " : " "} </a>
              </li> }
              {!props.task.isOpened &&
              <li>
                  <div className = {`card-icon-`+ props.task.status.name.replace(/\s+/g, '-').toLowerCase() + " " + `card-data-cell remove-border-left card-data-cell-icon card-data-cell-collapse-icon `}>
                    <label>{ i18next.t('pages.tickets.status') }</label>
                    <p>{ i18next.t(`ticket-task-statuses.${props.task.status.token}`) }</p>
                  </div>
              </li>}

              {props.task.isOpened &&
              <li><a className="btn btn-xs btn-default" onClick={() => props.toggleAddEditTicketTaskModal(props.task)}>{ i18next.t('form-labels.edit-task') }</a></li> }
                {props.activityEnabled && props.task.isOpened ?
                  <li>
                  <a className="btn btn-xs btn-default" onClick={() => props.toggleAddTicketTaskCommentModal(props.task)}>{ i18next.t('form-labels.add-task-comment') }</a> </li> : null}
          </ul>
        </li>
      </ul>
      <Collapse isOpened={props.task.isOpened} >
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-9">
          <div className="row">
            <div className="col-sm-12 col-md-4">
              <div
              className = {`card-icon-`+ props.task.status.name.replace(/\s+/g, '-').toLowerCase() + " " + `card-data-cell remove-border-left card-data-cell-icon`}
              >
                <label>{ i18next.t('pages.tickets.status') }</label>
                  <p>{props.task.status.name}</p>
              </div>
            </div>
            {props.task.assignedTo ?
            <div className="col-sm-12 col-md-4">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-owner">
                <label>{ i18next.t('pages.tickets.assigned-to') }</label>
                <p> {props.task.assignedTo.fullName}</p>
              </div>
            </div>: null}
            <div className="col-sm-12 col-md-4">
              <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-type">
                <label>{ i18next.t('pages.tickets.task-type') }</label>
                  <p>{props.task.type.name} </p>
              </div>
            </div>

              <div className="col-sm-12">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                  <label>{ i18next.t('pages.tickets.description') }</label>
                  <p>{props.task.description} </p>
                </div>
              </div>

          </div>

          {taskComments.map(comment => <TaskCommentActivityEntry key={comment.id} timezone={props.timezone} comment={comment} />)}

        </div>
        <div className="col-sm-12 col-md-6 col-lg-3">
          <div className="card-data-side-info">
            <div className="row">
              <div className="col-sm-12 form-group">
                <label>{ i18next.t('pages.tickets.created') }</label>
                <p>{TimeFormattingService.renderNormalTime(props.task.createdAt, props.timezone ? props.timezone : null)}</p>
              </div>
              <div className="col-sm-12 form-group">
                <label>{ i18next.t('pages.tickets.creator') }</label>
                <p>{createdByName}</p>
              </div>
              <div className="col-sm-12 form-group">
                <label>{ i18next.t('pages.tickets.updated') }</label>
                <p>{TimeFormattingService.renderNormalTime(props.task.lastUpdatedAt, props.timezone ? props.timezone : null)}</p>
              </div>
              <div className="col-sm-12">
                <label>{ i18next.t('pages.tickets.updater') }</label>
                <p>{updatedByName}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
      </Collapse>
      {!props.task.isOpened &&
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                    <label>{ i18next.t('pages.tickets.description') }</label>
                    <p>{props.task.description.substring(0,200)} </p>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

const TaskCommentActivityEntry = (props) => {
  const byName = props.comment.createdBy == null ? 'System' : props.comment.createdBy.fullName;
  return (
    <div className="task-detail-comment">
       <p className="comment-author-time">{byName}, {TimeFormattingService.renderNormalTime(props.comment.createdAt, props.timezone ? props.timezone : null)}</p>
       <p className="comment-text">{props.comment.comment}</p>
    </div>
  );
}

const TicketCommentActivityEntry = (props) => {
  const byName = props.comment.createdBy == null ? 'System' : props.comment.createdBy.fullName;
  return (
    <div className="task-ticket-comment task-ticket-icon task-ticket-comment-icon">
      <p className="comment-author-time">{byName}, {TimeFormattingService.renderNormalTime(props.comment.createdAt, props.timezone ? props.timezone : null)}</p>
      <p className="comment-text">{props.comment.comment}</p>
    </div>
  );
}

const TicketCommentFormLayout = (props) => {
  return (
    <div className="login-form">
      <form onSubmit={props.handleSubmit}>
        <Field
          type="text"
          name="comment"
          component={TextInput}
          label=""
          textarea={true}
        />
      </form>
    </div>
  );
}
const TicketCommentForm = reduxForm({ form: 'TicketCommentForm', validate })(TicketCommentFormLayout);

const TicketTaskCommentFormLayout = (props) => {
  return (
    <div className="login-form">
      <form onSubmit={props.handleSubmit}>
        <Field
            type="text"
            name="comment"
            component={TextInput}
            label=""
            textarea={true}
          />
      </form>
    </div>
  );
}
const TicketTaskCommentForm = reduxForm({ form: 'TicketTaskCommentForm', validate })(TicketTaskCommentFormLayout);

export default connect()(TicketActivityList);
